// HEADER B!!!

let myAccountPageItems = $('.menu-myaccount-page');

function relocateItems() {

	// Clone bottom menu for tablet
	// This way we have a normal menu and a hamburger menu
	if ($(window).width() <= 1199) {

		if ($('header .bottom-hamburger').length == 0) {
			$('header .bottom').clone().removeClass('bottom').addClass('bottom-hamburger').appendTo('.header-row');
		}

		$('header .top ul').addClass('d-none');

		$('.bottom-hamburger .bottom-menu').addClass('bottom-mobile-menu');

		$('header .bottom-menu').animate({
			opacity: 1
		},200);
	}

	// Remove hamburger menu when something bigger than tablet
	if ($(window).width() >= 1200) {

		if ($('header .bottom').length == 0) {
			$('header .bottom-hamburger').clone().removeClass('bottom-hamburger').addClass('bottom').appendTo('.header-row');
		}

		$('header .top ul').removeClass('d-none');
		
		$('header .bottom-hamburger').remove();
	}
	
	if ($(window).width() >= 768) {
		// Place the search bar back on the normal spot on desktop
		if ($('.middle .toggle_search-bar').length == 0) {
			$('.middle .logo').after($('.header-row .toggle_search-bar.mobile').clone().removeClass('mobile'));
		}

		$('header .bottom .top-mobile-menu').remove();
		$(".nav .header-image").remove();
		$('.nav .toggle_search-bar.mobile').remove();
		$('.header-image .toggle_search-bar').remove();


		$('header .bottom .top-mobile-menu').remove();
		$('.header-row .toggle_search-bar.mobile').remove();		

		if ($('header .bottom').length == 0) {

			$('header .bottom-hamburger').clone().removeClass('bottom-hamburger').addClass('bottom').appendTo('.header-row');
			$('header .bottom .top-mobile-menu').remove();
		}
	}
	
	if ($(window).width() <= 765){
		// Move search from the desktop spot to where it needs to be for mobile
		if ($('.header-row .toggle_search-bar.mobile').length == 0) {
			$('.header-row').append($('header .middle .toggle_search-bar').clone().addClass('mobile'));
		}

		// Remove search from the desktop spot so there is only one search on the page
		$('.header-row .middle .toggle_search-bar').remove();		

		

		$('header .bottom').remove();
	}

	if (myAccountPageItems.length > 0) {

		if ($(window).width() >= 768) {
			if (myAccountPageItems.find('li').length == 0) {
				myAccountPageItems.append($('header .bottom .item-myaccount ul > li').clone());
			}
		} else {
			$('.menu-myaccount-page li').remove();
		}
	}

	if ($(window).outerWidth() < 768) {
		$('header.header-b').animate({
			opacity: 1
		},200);

		$('header .bottom-menu').animate({
			opacity: 1
		},200);	
	}


	// Set desktop search.
    if($('.__search:not(.search-mobile)').length > 0) {
        new Search({
            element: $('.__search:not(.search-mobile)'),
            history: {
                enabled: config.website.search.search.history.enabled,
                maxItems: config.website.search.search.history.max_results,
            },
        });
    }
}

$(document).ready(function(){

	if ($(window).width() <= 768) {
		$(window).scroll(function () {
			if ($(this).scrollTop() > 0) {
				$('header .top').hide();
			} else {
				$('header .top').show();
			}
		});
	}

	$('header [data-cat-image]:not([data-cat-image=""])').on('mouseenter', function() {
		$('.cat-image img').show();
		$('.cat-image img').attr('src', $(this).data('cat-image'));
	});

	$('header [data-cat-image]:not([data-cat-image=""])').on('mouseleave', function() {
		$('.cat-image img').hide();
		$('.cat-image img').attr('src','#');
	});

	$('.menu-mobile-open').on('click', function() {

		//set special mobile class
		$('body').addClass('menu-mobile-open');
		
		//so/hide buttons
		$('header .menu-mobile-open').addClass('hide');
		$('header .menu-mobile-close').removeClass('hide');

		setOverlay('header', 'header');

		// Clone cart & account icon to mobile menu.
		$('header .bottom-hamburger .nav').append($('header .middle .contact').clone().addClass('mobile'));

		if ($(window).width() <= 1199) {
			//move top li items to hamburger menu
			$('header .top ul > li').clone().addClass('mobile').addClass('nav-menu-item').insertBefore('header .bottom-hamburger .nav .contact-first');
			$('header .bottom-hamburger .nav li.mobile a').removeClass('top-header-item ').addClass('header-subitem');
			$('header.header-b .contact .notification-label').addClass('d-none');
			$('header.header-b .contact .notification-label').removeClass('d-xl-none');
			$('header.header-b .contact .notification-label').removeClass('d-md-block');

			// if ($('.nav .webwinkelimage').length == 0) {
				$(".nav .header-image").remove();
				$(".header-image").clone().last().appendTo(".bottom-hamburger .nav").removeClass('d-none');
			// }

			// languages.
			$('header .top li.languages').clone().addClass('mobile').addClass('nav-menu-item').insertBefore('header .bottom-hamburger .nav .contact-first');
		}

		$('.bottom .bottom-container .notification-label').remove();

	});

	$(document).on('click', '.menu-mobile-close, .header-gradient', function () {
		$('body').removeClass('menu-mobile-open');
		$('header .menu-mobile-open').removeClass('hide');
		$('header .menu-mobile-close').addClass('hide');
		$('header.header-b .contact .notification-label').removeClass('d-none');
		$('header.header-b .contact .notification-label').addClass('d-xl-none');


		setOverlay('header','header');

		setTimeout(function () {
			$('header .bottom-hamburger .languages').remove();
			$('header .bottom-hamburger .nav li.mobile').remove();

			$('header .bottom-hamburger .nav .contact').remove();
		}, 500);
	});	

	$(window).on('resize', function() {
		relocateItems();
	});  

	relocateItems();

	let hoverMenuEnterTimer;
	let hoverMenuLeaveTimer;
	let isMenuItem;

    // Show sub menu (large dropdown).
	$(document).on('mouseenter', '.toggle-large-menu', function () {

		if ($(window).width() < 1200) {
			return;
		}

        clearTimeout(hoverMenuLeaveTimer);
        isMenuItem = $(this);

        if(!isMenuItem.hasClass('menu-hover')) {
            $('.toggle-large-menu').removeClass('menu-hover');
        }

        hoverMenuEnterTimer = setTimeout(function () {
            isMenuItem.addClass('menu-hover');

            if(!$('body').hasClass('menu-mobile-open')) {
				if($('.header-gradient').length == 0) {
					setOverlay('header','header');
				}
            }
        }, 0);
    });

    // Hide sub menu (large dropdown).
	$(document).on('mouseleave', '.toggle-large-menu', function () {

		if ($(window).width() < 1200) {
			return;
		}
		
        clearTimeout(hoverMenuEnterTimer);
        isMenuItem = $(this);

        hoverMenuLeaveTimer = setTimeout(function () {
            isMenuItem.removeClass('menu-hover');

            if(!$('body').hasClass('menu-mobile-open')) {
				if($('.header-gradient').length == 1) {
					setOverlay('header','header');
				}
            }
        }, 350);      
    });
});